
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/secondary-and-high-school",
      function () {
        return require("private-next-pages/secondary-and-high-school.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/secondary-and-high-school"])
      });
    }
  